import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/constants/languages/en';
import tr from '@/constants/languages/tr';

const resources = {
  en: { translation: en },
  tr: { translation: tr },
};

const getInitialLanguage = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('lang') || 'tr';
    }
  } catch {
    // localStorage erisim hatasi sessizce yoksayilir
  }
  return 'tr';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
